/**
 * Search results' loading lifecycle.
 *
 * Was shared by the profile and the personalized lists, which is where its
 * problems came from: consumers had to re-derive "is the user signed in" and "is
 * it safe to act" from a flat enum, and disagreed. WillNotLoad was never set by
 * any producer, only read.
 *
 * Search is the last holder. It has no identity dimension, so the enum fits it
 * and there is nothing to untangle. Profile identity is ProfileState
 * (lib/types/identity.ts); personalized lists are ResourceState
 * (lib/types/personalized-resource.ts).
 */
enum CompanionState {
  NotLoaded = 'NotLoaded',
  IsLoading = 'IsLoading',
  IsLoadedWithData = 'IsLoadedWithData',
  IsLoadedWithoutData = 'IsLoadedWithoutData',
  WillNotLoad = 'WillNotLoad',
  Error = 'Error'
}

export default CompanionState
